import {
  getItemsError,
  getItemsLoading,
  getItemsSuccess,
  loadStoreError,
  loadStoreLoading,
  loadStoreSuccess,
} from "../../reducers/Store/selectedStore";

export const setStore = (selectedStore) => async (dispatch) => {
  try {
    dispatch(loadStoreLoading());
    dispatch(loadStoreSuccess(selectedStore));
  } catch (error) {
    dispatch(loadStoreError("Unexpected Error!!!"));
  }
};

export const getItems = (data) => async (dispatch) => {
  try {
    dispatch(getItemsLoading());
    dispatch(getItemsSuccess(data));
  } catch (error) {
    dispatch(getItemsError(error));
  }
};
